/**
 * Created by zhangjingguo on 16/6/28.
 * FRAMECONTROLLER
 */

import Model from './model'
const model = new Model()
class Frame {
    /**
     * 获取微信签名
     * @param url
     * @returns {*}
     */
    static getWeixinJsApiSignature(url) {
        return model.post('frame/open/getWeixinJsApiSignature', { url: url || window.location.href.split('#')[ 0 ] })
    }

    /**
     * 使用ajax方法生成二维码
     * @param url
     * @param height
     * @param width
     * @return
     */
    static getQrcode(url, width, height) {
        return model.post(`/frame/open/qrcode?url=${url}&width=${width}&height=${height}`)
    }
}
export default Frame



// WEBPACK FOOTER //
// ./bootsets/models/frame.js